"use strict";

var FileSelect, React, ReactBootstrap, UploadImageButton, utils;

React = require("react");

ReactBootstrap = require("react-bootstrap");

FileSelect = require("../File");

utils = require("../../utils/utils");

UploadImageButton = React.createClass({
  displayName: "UploadImageButton",

  propTypes: {
    fileDestinationService: React.PropTypes.string.isRequired,
    addImageMarkdown: React.PropTypes.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      uploading: false
    };
  },
  uploadFile: function uploadFile(event) {
    var file;
    if (file = event.target.files[0]) {
      return this.setState({
        uploading: true
      }, (function (_this) {
        return function () {
          return _this.props.fileDestinationService(file, {
            complete: function complete() {
              return _this.setState({
                uploading: false
              });
            },
            error: function error() {
              return alert("error uploading");
            },
            success: function success(resp) {
              return _this.props.addImageMarkdown(_this.markdownImage(resp));
            }
          });
        };
      })(this));
    }
  },
  markdownImage: function markdownImage(resp) {
    var img, wrap;
    img = new Image();
    if (resp.url != null) {
      img.src = resp.url;
    }
    if (resp.alt != null) {
      img.alt = resp.alt;
    }
    if (resp.width != null) {
      img.width = resp.width;
    }
    if (resp.height != null) {
      img.height = resp.height;
    }
    wrap = document.createElement("div");
    wrap.appendChild(img);
    return wrap.innerHTML;
  },
  openFilePrompt: function openFilePrompt() {
    return this.refs.input.click();
  },
  render: function render() {
    if (this.state.uploading) {
      return React.createElement(
        ReactBootstrap.Button,
        { disabled: true, className: "btn-xs btn-gradient" },
        React.createElement(ReactBootstrap.Glyphicon, { glyph: "refresh" })
      );
    } else {
      return React.createElement(
        "div",
        null,
        React.createElement(
          ReactBootstrap.Button,
          { onClick: this.openFilePrompt, className: "btn-xs btn-gradient" },
          React.createElement(ReactBootstrap.Glyphicon, { glyph: "upload" })
        ),
        React.createElement(
          "div",
          { style: { display: "none" } },
          React.createElement("input", {
            ref: "input",
            type: "file",
            className: "upload form-control",
            onChange: this.uploadFile
          })
        )
      );
    }
  }
});

module.exports = UploadImageButton;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/Markdown/UploadImageButton.js
 ** module id = 584
 ** module chunks = 0
 **/